import React, { ReactElement, ReactNode } from "react";

import { CategoricalChartState } from "recharts/types/chart/types";

import { Box, Tooltip, Typography } from "@mui/material";
import ISONumber from "components/formatting/ISONumber";


interface TrendChartTooltipProps {
  children: ReactElement;
  state: CategoricalChartState | undefined;
  xAxisLabelField?: string;
}

export default function TrendChartTooltip(props: TrendChartTooltipProps): React.JSX.Element {
  let open = false;
  let queryRows: Array<ReactNode> = [];
  if (props.state?.activePayload) {
    open = true;
    queryRows = props.state.activePayload.filter((payload, index) => {
      return payload.value !== undefined;
    }).map((payload, index): ReactNode => {
      return (
        <Typography key={payload.dataKey} sx={{ color: payload.color }} >
          {payload.dataKey}:
                    <Box
            sx={{
              display: "inline-block",
              marginLeft: 1
            }}>
            <ISONumber number={payload.value} sx={{ fontWeight: "bold" }} />
          </Box>
        </Typography>
      );
    });
  }

  const xAxisLabelField = props.xAxisLabelField || "name";
  const activePayload = props.state?.activePayload?.[0];
  let title = "";
  if (activePayload) {
    title = activePayload.payload[xAxisLabelField];
  }
  
  return (
    <Tooltip
      open={open}
      followCursor={true}
      title={
        <Box>
          <Typography variant="h4" sx={{color: "inherit" }}>
            {title}
          </Typography>
          {queryRows}
        </Box>
      }>
      {props.children}
    </Tooltip>
  );
}
